<script>
import CustomPageCommon from '@/components/CustomPageCommon'

export default {
  extends: CustomPageCommon,
  async asyncData({ params, $bugsnag, $axios, redirect, store }) {
    const id = params.id
    const url = `/ca/${store.state.settings.school}/catalogPages/${
      store.state.settings.activeCatalog
    }/${id}`
    try {
      const page = await $axios.$get(url, {
        params: {
          published: true,
        },
      })
      return {
        page,
      }
    } catch (e) {
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  created() {
    this.$store.commit(
      'page/SET_CURRENT_PAGE_LABEL',
      this.page && this.page.name
    )
  },
}
</script>
